<template>
  <!-- 检索 -->
  <div class="retrieval">
    <div v-if="notes.length>0">注释</div>
    <div v-else>暂无注释</div>
    <div :key="index" v-for="(item, index) in notes">
      {{ item }}
    </div>
  </div>
</template>
<script>
  import {getNotes} from '../../api/exhibition'

  export default {
    name: 'notes',
    props: {
      bookId: {
        type: String,
      }
    },
    data() {
      return {
        notes: []
      };
    },

    mounted() {
      this.getData()
    },

    methods: {
      getData() {
        getNotes({
          typeId: this.$store.state.typeId,
          bookId: this.bookId
        }).then(res => {
          if (res.data.code == 200 && res.data.data.length!=0) {
            this.notes = res.data.data[0].replace('注释 ', '').split('  ')
          }
        })
      }

    },
  };
</script>

<style lang="less" scoped>
  .exhibition-left {
    &.close {
      .retrieval {
        display: none;
      }
    }

    &.open {
      .retrieval {
        display: block;
      }
    }
  }

  .retrieval {
    width: 16.667rem;
    height: 100%;
    position: relative;
    margin-top: 0rem;

    div {
      margin: .8rem 0;
      padding-left: .5rem;
      line-height: 1.5;
    }
  }
</style>
